import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// トスアップ商材一覧取得
export async function getSaleCompanyTossUpProducts(id: string) {
  try {
    const path = "saleCompanyTossUpProducts";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      productDatas: response.data.product_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// トスアップ商材登録
export async function postSaleCompanyTossUpProducts(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyTossUpProducts";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
